module.exports = __webpack_public_path__ + "img/bg2-img2.a60117db.png";